<template>
    <span>
        <AdminPage></AdminPage>
    </span>
</template>

<script>
// @ is an alias to /src
import AdminPage from '@/components/Admin/AdminPage.vue'

export default {
  name: 'About',
  props: {
    navButtons: {
      type: Array
    },
    primaryColor: {
      type: String
    },
    secondaryColor: {
      type: String
    },
    thirdColor: {
      type: String
    },
    buttonColor: {
      type: String
    }
  },
  components: {
    AdminPage
  }
}
</script>
